/* eslint-env browser */

import install from './install-twind'
install()
